<highcharts-chart
        [constructorType]="chartConstructor"
        [options]="chartOptions"
        style="width: 100%; display: block;"
/>